// extracted by mini-css-extract-plugin
export default {"compare-slider-handle":"style_compare-slider-handle__2xdGl"};